//const baseUrl = "http://192.168.168.57:8080/towing411/";
const baseUrl = "https://api.towing411.net/"

const BaseUrl={
    baseUrl
};

export default BaseUrl;